import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from "@angular/material";
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../store/reducers';
import * as dashboardActions from '../../pillar/dashboard/store/actions';
import { ModuleConfiguration } from '../submission.module.config';
import { SubmittingEntityListModel } from '../models/SubmittingEntityListModel';
import { JobsService } from '../services/JobsService';
import * as moment from 'moment';
import { SubmittingEntityModel } from '../models/SubmittingEntityModel';
import { DataSetAccessModel } from '../models/DataSetAccessModel';
import { DatabaseJobsModel } from '../models/DatabaseJobsModel';
import { UserService } from '../../customer/services/UserService';
import { LookupModel } from '../../common/models/LookupModel';

@Component({
  selector: 'brd-database-jobs-filter-dialog',
  templateUrl: './database-jobs-filter-dialog.component.html',
  styleUrls: ['./database-jobs-filter-dialog.component.scss']
})
export class DatabaseJobsFilterDialogComponent implements OnInit {
  databaseJobsForm: FormGroup;
  submittingEntities$: Observable<LookupModel[]>;
  selectedSubmittingEntity: SubmittingEntityModel;
  selectedSubmittingEntityKey: string;
  allowedDataSets: DataSetAccessModel[];

  constructor(private store: Store<any>,
    public dialogRef: MatDialogRef<DatabaseJobsFilterDialogComponent>,
    private formBuilder: FormBuilder,
    private jobsService: JobsService,
    private userService: UserService) {

    this.submittingEntities$ = userService.getCurrentUserSubmittingEntities(false).map(r => r.model);

    this.databaseJobsForm = this.formBuilder.group({
      startDate: [moment(), Validators.required],
      endDate: [moment(), Validators.required],
      submittingEntity: [{ key: 'Select All', name: 'Select All' }, Validators.required],
      dataSets: [[], Validators.required]
    });
  }

  ngOnInit() {
    this.store.select(fromStore.getSubmittingEntitySelection)
      .subscribe((v: SubmittingEntityModel) => {
        if (v) {
          this.selectedSubmittingEntity = v;
          this.allowedDataSets = v.allowedDataSets.filter(a => a.canSubmit == true);
          }
      });
  }

  itemDisplay(item?: LookupModel): string | undefined {
    return item ? item.description : undefined;
  }

  submittingEntityChanged(model: SubmittingEntityListModel): void {
    this.store.dispatch(new dashboardActions.GetSelectionAction(ModuleConfiguration.moduleName, SubmittingEntityModel, { key: model.key }));
    this.selectedSubmittingEntityKey = model.key;
  }

  triggerJobs() {
    var databaseJobsModel = new DatabaseJobsModel();
    databaseJobsModel.submittingEntityKey = this.selectedSubmittingEntityKey;
    databaseJobsModel.startDate = this.databaseJobsForm.controls.startDate.value;
    databaseJobsModel.endDate = this.databaseJobsForm.controls.endDate.value;
    databaseJobsModel.dataSets = this.databaseJobsForm.controls.dataSets.value;

    this.dialogRef.close(this.jobsService.triggerDatabaseJobs(databaseJobsModel).subscribe(result => {
      var res = result.model;
    }));
  }
}


// WEBPACK FOOTER //
// ./src/app/submission/components/database-jobs-filter-dialog.component.ts